import { Text, useMainContext } from '../../../../../modules/Dashboard'
import { usePredictContext } from '../../../context/PredictContextProvider'
import { useNavigate } from 'react-router-dom'
import LeftIcon from '../../../../../components/icons/Left'

// Icons
import { ReactComponent as NewsEllipse } from '../../../assets/news-ellipse.svg'
import { ReactComponent as FundEllipseTop } from '../../../assets/fund-ellipse-top.svg'
import { ReactComponent as TechChart } from '../../../assets/tech-chart.svg'
import AssistantIcon from '../../AssistantIcon'
import LockedAssistant from '../../LockedAssistant'

const RCryptoAnalyzers = ({ loading, assistants = [] }) => {
    const {
        main: { lang },
    } = useMainContext()
    const { assistant, isLocked } = usePredictContext()
    const navigate = useNavigate()

    const handleSelectAssistant = (method) => {
        if (isLocked) return
        assistant.setAssistant(method)
        navigate(`/analyze/assistant/crypto?step=tickers`)
    }

    // Skeleton loader
    const SkeletonCard = ({ full = false }) => (
        <div
            className={`bg-cardBgDark rounded-xl p-4 animate-pulse h-[180px] flex flex-col justify-between ${full ? 'col-span-2' : ''
                }`}
        >
            <div className="h-5 bg-gray-600 rounded w-3/4"></div>
            <div className="h-4 bg-gray-600 rounded w-full mt-2"></div>
            <div className="h-4 bg-gray-600 rounded w-5/6 mt-2"></div>
            <div className="h-4 bg-gray-600 rounded w-1/3 mt-auto"></div>
        </div>
    )

    return (
        <div>
            <div className="grid grid-cols-1 gap-5 min-h-[150px]">
                {loading
                    ? // 🧱 Skeleton loading
                    [<SkeletonCard full key={0} />, ...Array.from({ length: 2 }).map((_, i) => <SkeletonCard key={i + 1} />)]
                    : // 🎯 Dynamic assistants
                    assistants.map((item, index) => (
                        <div
                            key={item.value || index}
                            onClick={() => handleSelectAssistant(item)}
                            className={`relative overflow-hidden bg-gradient-to-r from-[#8A16F8] to-[#273FE9] rounded-2xl cursor-pointer transition-all hover:scale-[1.02] `}
                        >
                            {/* If is Locked */}
                            <LockedAssistant />

                            {/* Card Content */}
                            <div className="flex flex-col gap-2 relative z-[2] h-full p-6">
                                <div className='flex items-center gap-2'>
                                    <AssistantIcon assistantValue={item.value} />
                                    <Text tid={item.label} className="text-xl !text-white" />
                                </div>
                                <p className="text-sm">{item.description}</p>

                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default RCryptoAnalyzers
